import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, Question } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { Link } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import UserAddModal from "../partials/UserAddModal";
import UserUpdateModal from "../partials/UserUpdateModal";
import { toast, ToastContainer } from "react-toastify";
import Moment from 'moment';
import * as myConstList from "./baseUrl"

const baseUrl = myConstList.baseUrl
const token = localStorage.getItem("jwtToken");
const configs = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
class Users_pending_record extends Component {

    constructor(props) {
        super(props);

        this.columns = [
            {
                key: "_id",
                text: "S.No.",
                className: "id",
                align: "left",
                sortable: true,
                cell: (row, index) => index + 1
            },
            
            {
                key: "email",
                text: "Email",
                className: "email",
                align: "left",
                sortable: true
            },
       
         

         
            {
                key: "kycstatus",
                text: "KYC Status",
                className: "status",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                            {record.kycstatus}
                            {/* {record.status === '1' ? "Pending" : (record.status === '2' ? "Verified" : <Link to={"/reject-reason/" + record.id + "/" + 24} className="btn5">Rejected <i className="fa fa-info-circle"></i></Link>)} */}
                        </Fragment>
                    );
                }
            },
            {
                key: "selfistatus",
                text: "Selfie Status",
                className: "status",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                            {record.selfistatus}
                            {/* {record.status === '1' ? "Pending" : (record.status === '2' ? "Verified" : <Link to={"/reject-reason/" + record.id + "/" + 24} className="btn5">Rejected <i className="fa fa-info-circle"></i></Link>)} */}
                        </Fragment>
                    );
                }
            },
            {
                key: "updatedAt",
                text: "Date & Time",
                className: "date",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                            {Moment(record.createdAt).format('lll')}
                        </Fragment>
                    );
                }
            },
            {
                key: "action",
                text: "Action",
                className: "action",
                width: 100,
                align: "left",
                sortable: false,
                cell: record => {
                    return (
                        <Fragment>
                            {/* {(record.identity_status !==undefined || record.identity_status2 !==undefined) && */}
                            <Link to={"/verifyKyc/" + record._id} className="admin_btn">Verify</Link>
                            {/* } */}
                        </Fragment>
                    );
                }
            }
        ];

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            filename: "Verify Pending List",
            no_data_text: 'No user found!',
            button: {

                // print: true,
                // csv: true
            },
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Search in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.state = {
            records: []
        };

        this.state = {
            currentRecord: {
                id: '',
                name: '',
                email: '',
                password: '',
                password2: '',
            }
        };

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        if (this.props.auth.user.verifyPending !== undefined && this.props.auth.user.verifyPending !== 1) {
            this.props.history.push("/dashboard");
        }
        this.getData();
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.user.verifyPending !== undefined && nextProps.auth.user.verifyPending !== 1) {
            this.props.history.push("/dashboard");
        }

        this.getData();
    }

    getData() {
        axios
            .get(baseUrl + "/api/v1/getkycpending",configs)
            .then(res => {
                this.setState({ records: res.data.user })
            })
            .catch()
    }

    editRecord(record) {
        this.setState({ currentRecord: record });
    }
    handleChange = (e) => {
        if(e.target.value == "indian"){
             let filterData =  this.state.records.filter((filterdData)=>{
                return filterdData.country_code == "+91"
             })
             this.setState({ records: filterData })
        }
        if(e.target.value == "non-indian"){
             let filterData =  this.state.records.filter((filterdData)=>{
                return filterdData.country_code !== "+91"
             })
             this.setState({ records: filterData })
        }


    }

    deleteRecord(record) {
        axios
            .post(baseUrl + "/api/user-delete", { _id: record._id })
            .then(res => {
                if (res.status === 200) {
                    toast(res.data.message, {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
            })
            .catch();
        this.getData();
    }

    pageChange(pageData) {
        console.log("OnPageChange", pageData);
    }

    render() {
        return (
            <div>
                <Navbar />
                <div className="d-flex" id="wrapper">
                    <Sidebar />
                    <UserAddModal />
                    <UserUpdateModal record={this.state.currentRecord} />
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <button className="btn btn-link mt-3" id="menu-toggle"><FontAwesomeIcon icon={faList} /></button>
                            <h4 className="mt-2 man_hadding mb-3">Users Pending verify List</h4>
                            {/* <select onClick={this.handleChange}>
                                <option value="indian">Indian</option>
                                <option value="non-indian">Non-Indian</option>
                            </select> */}
                            <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                onPageChange={this.pageChange.bind(this)}
                            />
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        );
    }

}

Users_pending_record.propTypes = {
    auth: PropTypes.object.isRequired,

};

const mapStateToProps = state => ({
    auth: state.auth,

    records: state.records
});

export default connect(
    mapStateToProps
)(Users_pending_record);
